/**
 * Temas disponíveis na aplicação.
 */
export enum ThemesEnum {
  LIGHT = 'LIGHT',
  DARK = 'DARK',
}
